"use client";

import React from "react";
import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DignityThroughBasicNeeds() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223894" id="the-beginning-of-forever" className="bg-background text-foreground w-full">
      <div className="flex flex-col lg:flex-row min-h-[90vh] w-full">
        
        {}
        <div className="w-full lg:w-[60%] bg-background flex flex-col justify-center px-6 py-20 md:px-12 lg:px-20 xl:px-28 relative overflow-hidden">
          {}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-30">
            <div className="absolute -top-[20%] -left-[10%] w-[70%] h-[70%] rounded-lg bg-primary/10 blur-[120px]" />
          </div>

          <div ref={textRef} className={`relative z-10 max-w-3xl transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h1 className="font-default text-5xl md:text-6xl lg:text-7xl xl:text-8xl text-foreground leading-tight mb-8 tracking-tighter">
              Anthony & <br className="hidden md:block" />
              <span className="text-primary italic font-serif">Lily's Celebration</span>
            </h1>
            
            <p className="font-default text-lg md:text-xl text-muted-foreground mb-12 max-w-2xl leading-relaxed">
              We invite you to join us as we begin our journey together. A timeless celebration of love, commitment, and the beautiful moments that brought us to this day.
            </p>
            
            <div className="flex flex-col sm:flex-row flex-wrap gap-5 items-start sm:items-center">
              <Button asChild size="lg" variant="default" className="h-14 px-8 text-base rounded-md shadow-md hover:shadow-lg transition-shadow bg-primary text-primary-foreground">
                <Link to="/RSVPPage">Kindly RSVP</Link>
              </Button>
              
              <Button asChild size="lg" variant="outline" className="h-14 px-8 text-base rounded-md border-border text-foreground hover:bg-accent hover:text-accent-foreground transition-colors group">
                <Link to="/OurStoryPage">
                  <span className="relative flex h-3 w-3 mr-3 items-center justify-center">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-primary opacity-75"></span>
                    <span className="relative inline-flex rounded-lg h-2.5 w-2.5 bg-primary"></span>
                  </span>
                  <Play className="size-4 mr-2 fill-current opacity-70 group-hover:opacity-100 transition-opacity" />
                  Our Love Story
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="w-full lg:w-[40%] h-[50vh] lg:h-auto relative overflow-hidden bg-muted">
          <div ref={imageRef} className={`absolute inset-0 w-full h-full transition-all duration-[1500ms] ease-out ${isImageVisible ? "scale-100 opacity-100" : "scale-110 opacity-0"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/anthony_lily_wedding_portrait.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/anthony_lily_wedding_portrait.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/anthony_lily_wedding_portrait.png-wvc-sizes" alt="Anthony and Lily in a romantic wedding portrait" className="w-full h-full object-cover object-center" loading="lazy" />
            {}
            <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent lg:hidden" />
          </div>
        </div>

      </div>
    </section>;
}